import api from './api';

/**
 * Inspection Service (Admin Panel)
 */

// ==================== INSPECTOR MANAGEMENT ====================

export const getInspectorList = async (params?: any) => {
  const response = await api.get('/admin/inspections/inspectors', { params }) as any;
  return response;
};

export const toggleInspector = async (data: {
  storeId: string;
  isInspector: boolean;
  commissionSplit?: number;
}) => {
  // Backend validator expects inspectorCommissionSplit (not commissionSplit)
  const payload = {
    storeId: data.storeId,
    isInspector: data.isInspector,
    inspectorCommissionSplit: data.commissionSplit,
  };
  const response = await api.post('/admin/inspections/inspectors/toggle', payload) as any;
  return response;
};

// ==================== INSPECTION MANAGEMENT ====================

export const getAllInspections = async (params?: {
  page?: number;
  limit?: number;
  status?: string;
  storeId?: string;
  feeRefunded?: 'true' | 'false';
}) => {
  const response = await api.get('/admin/inspections', { params }) as any;
  return response;
};

export const overrideInspectionResult = async (data: {
  orderItemId: string;
  result: 'approved' | 'rejected';
  notes?: string;
}) => {
  // ✅ FIX INS-M4: backend validator only accepts `adminNote` (Joi rejects unknown `notes` → 400).
  const payload = {
    orderItemId: data.orderItemId,
    result: data.result,
    adminNote: data.notes,
  };
  const response = await api.post('/admin/inspections/override-result', payload) as any;
  return response;
};

// ==================== PENALTY MANAGEMENT ====================

export const getPenalties = async (params?: {
  status?: string;
  storeId?: string;
  type?: string;
  page?: number;
  limit?: number;
}) => {
  const response = await api.get('/admin/inspections/penalties', { params }) as any;
  return response;
};

export const resolvePenalty = async (penaltyId: string, data: {
  action: 'approve' | 'waive';
  note?: string;
}) => {
  const response = await api.post(`/admin/inspections/penalties/${penaltyId}/resolve`, data) as any;
  return response;
};
